<template>
  <div>
    <CCard class="content-fade-in mt-3p5">
        <CCardHeader>
            <span class="dot-custom dot-success" v-if="config.isActive == true">
                <b>Cấu hình: {{ config.value + " - " + config.name}}</b>
            </span>
            <span v-else class="dot-custom dot-danger">
                <b>Cấu hình: {{ config.value + " - " + config.name}}</b>
            </span>
            <br/>
            <b>Địa bàn: {{ config.location }}</b>

            <CButton style="float: right" color="secondary" class="btn-action-primary" @click="$router.go(-1)"><i
                class="fa fa-reply"></i>&nbsp;Hủy bỏ
            </CButton>
        </CCardHeader>
        <CCardBody>
            <CRow>
                <CCol xs="12" sm="12" md="12" lg="12" xl="12">
                    <ConfigTextToSpeechLineList :configId="$route.params.id"></ConfigTextToSpeechLineList>
                </CCol>
            </CRow>

            <CRow>
                <CCol xs="12" sm="12" md="12" lg="12" xl="12">
                    <ConfigTextToSpeechSpeedList :configId="$route.params.id"></ConfigTextToSpeechSpeedList>
                </CCol>
            </CRow>
        </CCardBody>
    </CCard>
  </div>
</template>
  
<script>
import ConfigTextToSpeechLineList from "./ConfigTextToSpeechLineList.vue";
import ConfigTextToSpeechSpeedList from "./ConfigTextToSpeechSpeedList.vue";

export default {
  name: "ConfigTextToSpeechForm",
  components: {
    ConfigTextToSpeechLineList,
    ConfigTextToSpeechSpeedList
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;
    return {
      config: {
      },
      idField: {
        data: {
          model: that.$route.params.id,
          name: "id",
        },
      },
    };
  },
  methods: {
    loadData() {
        let that = this;
        this.$helper.loadDataSource({
          loading: that.loading,
          url: "/text-to-speech-config/find-by-id",
          isJsonContentType: false,
          dataSubmit: function () {
            return {id: that.idField.data.model}
          },
          successCallback: function (response) {
            that.config = response.data.data
          },
          errorCallback: function (error) {
            that.$helper.handleError(that.$router, error);
          }
        });
      },
  },
  created: function () {},
  mounted() {
    this.loadData();
  },
  watch: {},
  computed: {},
};
</script>